import classNames from "classnames";
import NavbarDual from "components/navbars/navbar-dual/NavbarDual";
import NavbarTopHorizontal from "components/navbars/navbar-horizontal/NavbarTopHorizontal";
import NavbarTopDefault from "components/navbars/navbar-top/NavbarTopDefault";
import { useAppContext } from "providers/AppProvider";
import { useMainLayoutContext } from "providers/MainLayoutProvider";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppDispatch } from "../redux/HooksRedux";
// import { getUserProfileAction } from "../redux/User/userActions";
import { useEffect } from "react";

import {
  AdminRolePermissionProvider,
  PermissionGate,
} from "permissions/AdminRolePermissionGate";

const MainLayout = () => {
  const {
    config: { navbarPosition },
  } = useAppContext();

  const dispatch = useAppDispatch();
  const { contentClass } = useMainLayoutContext();
  // const getUserProfile = async () => {
  //   try {
  //     dispatch(getUserProfileAction());
  //     // eslint-disable-next-line
  //   } catch (error: any) {
  //     console.log("Failed to get user profile", error);
  //     toast.error(error.response.data.message);
  //   }
  // };

  // useEffect(() => {
  //   getUserProfile();
  // }, []);

  return (
    <AdminRolePermissionProvider>
      <Container fluid className="px-0">
        {/* Sidebar removed — global navigation lives in the top bar. */}
        {navbarPosition === "vertical" && <NavbarTopDefault />}
        {(navbarPosition === "horizontal" || navbarPosition === "combo") && (
          <NavbarTopHorizontal />
        )}
        {navbarPosition === "dual" && <NavbarDual />}

        <div className={classNames(contentClass, "content", "ab-content-full")}>
          <PermissionGate>
            <Outlet />
          </PermissionGate>
        </div>
      </Container>
    </AdminRolePermissionProvider>
  );
};

export default MainLayout;
